<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let item of receivedValues">
  <tr *ngIf="item.DocumentType">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationreceived.document-type' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.DocumentType }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Status && item.Status >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationreceived.status' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.Status | receivedstatus }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Comment">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationreceived.comment' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-installationreceived_comment ir-ph1" [innerHtml]="item.Comment"></span>
      </p>
    </td>
  </tr>
</table>
